import { Api } from "./Api.class";
const endpoint = "person_skills";
const personSkillsAPI = new Api(endpoint);
export default personSkillsAPI;
